<template>
  <div class="app">
    <router-view />
  </div>
</template>
<script>
import Cookie from 'js-cookie'
export default {
  data() {
    return {};
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    Cookie.remove('MK_USER_ID', {path: '/', domain: '.aiclk.com'});
    Cookie.remove('NAGATO_PROOF', {path: '/', domain: '.aiclk.com'});
  },
  methods: {
    getUrlParams(url) {
      try {
          const URL = url.split('?')[1];
          let obj = {}; // 声明参数对象
          let arr = URL.split("&");
          for (let item of arr) {
            let arrNew = item.split("="); 
            obj[arrNew[0]] = arrNew[1];
          }
          return obj;
      } catch (e) {
          return null;
      }
    },
    async init() {
        const params = this.getUrlParams(window.location.href);
        const { token, id } = params || {};
        if(token && id){
          const expires = new Date();
          expires.setTime(expires.getTime() + (24 * 60 * 60 * 1000));

          Cookie.set('NAGATO_PROOF', token, {
            expires: 1,
            path: '/',
            domain: '.aiclk.com'
          })

          Cookie.set('MK_USER_ID', id, {
            expires: 1,
            path: '/',
            domain: '.aiclk.com'
          })

          setTimeout(() => {
            window.location.replace(window.location.origin + '/appmanage');
          }, 100)  
        }

    },
  },
};
</script>

<style lang="scss">
@import '~@/theme/index.scss';
.app {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
}
</style>
